import { gql } from '@apollo/client';

const booking = `
  reference
  outboundExtras {
    ...product
  }
  inboundExtras {
    ...product
  }
  hotels {
    cancelled
    hotelId
  }
  insurances {
    cancelled
    itemRef
  }
  travelPassProducts {
    cancelled
    type
  }
	passengers {
		...passenger
	}

`;
const product = `
  fragment product on Product {
    itemRef
    tariffDetails {
      tariffCode
    }
    type
    cancelled
    passenger {
      ...passenger
   }
  }
`;

const passenger = `
  fragment passenger on Passenger {
     id
     uuid
     type
     firstName
     lastName
     email
     phoneNumber
     birthDate
     loyaltyNumber
     disabilityType
     discountCards {
       code
       identifier
       name
       requiresPassengerIdentifier
     }
     travelDocumentsRequired {
       travelDocumentType
       required
     }
   }
`;

export default gql`
  query extras($reference: String!) {
    booking(reference: $reference) {
      ${booking}
    }
  }

  ${product}
  ${passenger}
`;
